import { isSameId } from "../../helpers";
export default function (store, { cardId }) {
    const state = store.getState();
    const { currentUser } = state;
    if (!cardId || !currentUser) {
        return;
    }
    const cards = state.cards.map(c => {
        if (isSameId(c.id, cardId)) {
            return {
                ...c,
                votes: [...(c.votes || []), currentUser],
            };
        }
        return c;
    });
    store.setState({ cards });
}
//# sourceMappingURL=add.js.map